import { Badge } from "@drone-js/core";
import { AdaptiveBadge } from "apps/propertySelection/automaticLists/AdaptiveBadge";
import type { FunctionComponent } from "react";
import { useStaticDataAtomValue } from "../staticDataAtom";

interface Props {
    publishing: boolean;
}

export const PropertyBadge: FunctionComponent<Props> = ({ publishing }) => {
    const {
        cmsData: {
            complete: {
                publishingInProgressText,
                listingIncompleteText,
                thisListingIsBeingReviewedText,
                pleaseAllowAFewDaysForCompletionText,
            },
        },
    } = useStaticDataAtomValue();
    if (publishing) {
        return (
            <AdaptiveBadge
                variant="basic.notice"
                label={publishingInProgressText}
                tooltip={{
                    title: publishingInProgressText,
                    content: `${thisListingIsBeingReviewedText} ${pleaseAllowAFewDaysForCompletionText}`,
                }}
            />
        );
    }

    return <Badge variant="basic.urgency" my="auto" label={listingIncompleteText} />;
};
